import { render } from "./TableFormDialog.vue?vue&type=template&id=0bc8a0d2&scoped=true"
import script from "./TableFormDialog.vue?vue&type=script&lang=js"
export * from "./TableFormDialog.vue?vue&type=script&lang=js"

import "./TableFormDialog.vue?vue&type=style&index=0&id=0bc8a0d2&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc8a0d2"]])

export default __exports__